import { Deserializable } from "@app/interfaces/deserializable";
import { UseNotice } from './use-notice';
import { Webauthentication } from './webauthentication';

export class CustomerAgreement implements Deserializable {

    id: number;
    co: string;
    acctNum: string;
    agreement: string;
    agreementDate: Date;
    useNoticesId: UseNotice;
    webauthenticationId: Webauthentication;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }
}
